import type { FaireProductEntity } from "../../entity_types/product";

export const p_v3kmnnuybg: FaireProductEntity = {
  token: "p_v3kmnnuybg",
  type: "product",
  name: "Sweet Grace Mineral Soaking Salts | Bath, Self Care Gift",
  brandToken: "b_be6rwkua52",
  brandName: "Bridgewater Candle Company",
  imageUrl:
    "https://cdn.faire.com/fastly/0b825ae2f5dc5d2c5a1ff8b5333344dfa72380815929c958216ef75c4c835ada.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f8e4856f9d46dfffadb67b9ce6f6b3db716401f3cd5b68485f0d4833dba0e2f.jpeg",
    "https://cdn.faire.com/fastly/04076b6370973665b7f2d48da12a74f1f5366d1bce41600dd98b96952312614e.jpeg",
    "https://cdn.faire.com/fastly/ec5030e7a6da763d5e6626693599e03bab576c7a164c5c6487abaf6cf58a2bd3.jpeg",
    "https://cdn.faire.com/fastly/e7a3a568d995278a3496b015a8907e06157b54dc453b85485a146076612d7769.jpeg",
    "https://cdn.faire.com/fastly/e1dc167f1841b48a275778114d719326c8e59bf53fb24227dbea166326dd920e.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "Sweet Grace Mineral Soaking Salts bring our #1 best-selling fragrance into a relaxing spa-like self-care essential customers love. This luxurious 2 lb bath soak blends Epsom salt and pink Hawaiian sea salt to help relax muscles, soothe skin, and create a calming at-home spa experience.\n\nPerfect for self-care routines and all-occasion gifting, these soaking salts are a favorite for Mother’s Day, spa gifts, holidays, birthdays, and everyday relaxation. Infused with the uplifting Sweet Grace fragrance, each bath becomes a peaceful escape customers return to again and again.\n\nSimply add 1–2 cups to warm bath water and unwind.\n\nFragrance Description: With exotic passion fruit, sparkling tea and classic patchouli, Sweet Grace is undeniably warm, peaceful and pure.\n\nSize: 2 lb\nCase Pack: 6",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:46.527Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
